module.exports = __webpack_public_path__ + "static/media/logo-white.fab45c5f.svg";